/**
 * 根据操作类型和操作前状态生成管理操作成功提示。
 * @param operation 操作字段
 * @param currentStatus 操作前的状态
 * @param stickyTypeValue 置顶类型，0 表示取消置顶
 */
export const getManageOperationSuccessMessage = (
  operation: string,
  currentStatus: boolean | number,
  stickyTypeValue = 0,
): string => {
  if (operation === 'isSticky') {
    return stickyTypeValue === 0 ? '已取消置顶' : '已置顶';
  }

  // isDisplay 表示帖子是否正常展示：true 为正常展示，false 为已屏蔽。
  // 保持旧版接口仍传入原始 isDisplay，只反向处理成功提示语义。
  if (operation === 'isDisplay') {
    return currentStatus ? '已屏蔽本帖' : '已取消屏蔽';
  }

  const successMessages: Record<string, [string, string]> = {
    isEssence: ['已加精', '已取消加精'],
    isSink: ['已沉帖', '已取消沉帖'],
    isHidden: ['已隐藏本帖', '已展示本帖'],
    isRecommend: ['已推荐', '已取消推荐'],
  };
  const messages = successMessages[operation];

  return messages ? messages[currentStatus ? 1 : 0] : '操作成功';
};
